import moment from 'moment';
import api from '@/api/orders';

const orders = {
  namespaced: true,

  state: {
    current: null,
    orders: [],
    pagination: {},
  },

  getters: {
    current: state => state.current,
    orders: state => state.orders,
    pagination: state => state.pagination,
  },

  actions: {
    async getOrder({ commit }, orderId) {
      try {
        const { data, success } = await api.getOrder(orderId);
        await commit('SET_CURRENT', data);
        return { success };
      } catch (error) {
        return errorResponse(error, "There's been an error, please try again later");
      }
    },

    async update({ commit }, { form, orderId }) {
      try {
        const { success, message, data } = await api.update(orderId, form);
        if (success) {
          commit('SET_CURRENT', data);
        }
        return { success, message, data };
      } catch (error) {
        return errorResponse(error, "There's been an error, please try again later");
      }
    },

    async toggleState({ commit }, orderId) {
      const { success, message, data } = await api.toggleState(orderId);
      if (success) {
        commit('SET_ORDER_STATE', { orderId, data });
      }
      return { success, message };
    },

    async generateOrderReport(_, orderId) {
      try {
        const data = await api.generateOrderReport(orderId);
        if (data.size) {
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(new Blob([data]));
          const fileName = 'studeo-order-report_' + moment().format('YYYY-MM-DD') + '.pdf';
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
        } else {
          throw new Error('There was an error while generating the report');
        }
      } catch (error) {
        throw new Error('There was an error while generating the report');
      }
    },

    async submitOrder(_, orderId) {
      try {
        const { success, message } = await api.submitOrder(orderId);
        return { success, message };
      } catch (error) {
        throw new Error('There was an error while submitting your order. Please try again later.');
      }
    },
  },

  mutations: {
    SET_CURRENT: (state, payload) => {
      state.current = payload;
    },

    SET_ORDERS: (state, payload) => {
      state.orders = payload;
    },

    SET_PAGINATION(state, payload) {
      state.pagination = payload;
    },

    SET_ORDER_STATE: (state, payload) => {
      state.orders = [
        ...state.orders.map(order => (order.id !== payload.orderId ? order : { ...order, ...payload.data })),
      ];
    },
  },
};

function errorResponse(error, message) {
  console.log(error);
  return {
    success: false,
    error: error,
    message: message,
  };
}

export default orders;
